<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <!-- 导出按钮 -->

      <template #end>
        <el-form-item class="endBtn">
          <el-button type="primary" icon="el-icon-download" @click="Export(`运费统计表`)">导出</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true" :showTotal="true"
      :getTotal="getTotal" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  name: "FinanceFeightStatistics",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'order',
      breadcrumb: [
        { name: "财务管理", path: `/finance/feightStatistics` },
        { name: "运费统计表", path: `/finance/feightStatistics` },
      ],
      formInline: {
        date: "",
        fleet: "",
        license: "",
        pname: "",
        driver: "",
      },
      formCtrl: [
        {
          label: "卸货日期",
          keyName: "edittime",
          placeholder: "请选择日期",
          type: "date",
        },
        {
          label: "车队长",
          keyName: "fleet",
          placeholder: "请选择车队长",
          type: "select",
          options: [],
        },
        {
          label: "车牌号",
          keyName: "license",
          placeholder: "请填写车牌号",
          type: "text",
        },
        {
          label: "客户名称",
          keyName: "pname",
          placeholder: "请填写客户名称",
          type: "text",
        },
        // {
        //   label: "司机：",
        //   keyName: "driver",
        //   placeholder: "请填写司机姓名",
        //   type: "text",
        // },
      ],
      cols: [
        { prop: "license", label: "车牌号", width: 100 },
        { prop: "shname", label: "客户名称" },
        { prop: "starttime", label: "装货日期", width: 150 },
        { prop: "inton", label: "装货重量", align: 'right', className: 'pr30', width: 120 },
        { prop: "coaddress", label: "装货地址", width: 150 },

        { prop: "edittime", label: "卸货日期", width: 150 },
        { prop: "unton", label: "卸货重量", align: 'right', className: 'pr30', width: 120 },
        { prop: "enaddress", label: "卸货地址", width: 150 },
        { prop: "kuiton", label: "亏吨重量", align: 'right', className: 'pr30', width: 120 },
        { prop: "ceton", label: "承担的亏吨重量", align: 'right', className: 'pr30', width: 140 },
        { prop: "dtonprice", label: "亏吨单价", align: 'right', className: 'pr30', width: 140 },
        { prop: "kuitotal", label: "亏吨金额", align: 'right', className: 'pr30', width: 120 },
        { prop: "cprice", label: "公司单价", align: 'right', className: 'pr30', width: 120 },
        { prop: "freight", label: "公司运费", align: 'right', className: 'pr30', width: 120 },
        { prop: "dprice", label: "司机单价", align: 'right', className: 'pr30', width: 120 },
        { prop: "infreight", label: "司机运费", align: 'right', className: 'pr30', width: 120 },
        { prop: "dtotal", label: "出车费用", align: 'right', className: 'pr30', width: 120 },
        { prop: "message", label: "信息费", align: 'right', className: 'pr30', width: 120 },
        { prop: "profit", label: "毛利润", align: 'right', className: 'pr30', width: 120 },
      ],
      getTotalProperty: ['unton', 'dunton', 'ceton', 'dtonmoney', 'message', 'infreight', 'dfreight', 'freight', 'dtotal', 'profit'],
      getListUrl: 'freightrec',
    };
  },
  methods: {},
  watch: {
    formCtrl: {
      deep: true,
      handler() {
        // console.log(newVal)
        // console.log('formCtrl1', this.formCtrl)
        const { fleetIdx } = this.$route.query
        // console.log({...this.formCtrl[1]})
        // console.log(fleetIdx)
        if (fleetIdx && this.formCtrl[1].options[fleetIdx]) {
          this.formInline.fleet = this.formCtrl[1].options[fleetIdx].value
        }
        this.$nextTick(this.getList)
      },
    }
  },
  mounted() {
    this.getFleet()
  },
};
</script>
<style lang="less" scoped>
/deep/ .fillet .el-form--inline .el-form-item:nth-child(2) {
  margin-right: 0px;
  padding-right: 80px;
  position: relative;

  &::after {
    position: absolute;
    content: "";
    right: 40px;
    top: 6px;
    width: 1px;
    height: 28px;
    overflow: hidden;
    background-color: #EBEDF0;
  }
}
</style>